import { configureStore } from '@reduxjs/toolkit'
import { baseApi } from 'modules/core/services/api/base-api'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import { reduxBreadcrumbsMiddleware } from 'services/error-reporting/redux-breadcrumbs'
import { persistConfig } from './persist-config'
import rootReducer from './reducers'

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(baseApi.middleware)
      // Dispatched action types become error-reporting breadcrumbs
      .concat(reduxBreadcrumbsMiddleware),
  devTools: process.env.NODE_ENV === 'development',
})

window.globalStore = store

export const persistor = persistStore(store)
export default store

export * from './schema'
